import { gql } from "@apollo/client";

export default gql`
  query getActions($input: GetActionsInput){
    getActions(input: $input){
        success
        data{
            docs{
                _id
                channelIds
                customer
                type
                name
                description
                instructions
                collectInfo{
                    _id
                    type
                    name
                    description
                }
                customFieldInfo
                headers{
                    key
                    value
                }
                url
                method
                body
                requiresConfirmation
                formData{
                    key
                    value
                }
                formDataUrlEncoded{
                    key
                    value
                }
                responseMapping{
                    fieldId
                    value
                }
                platformAction{
                    type
                    method
                }
                createdAt
                updatedAt
            }
            totalRecords
            hasNextPage
        }
        code
        message
    }
}
`
